var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { courseApiRequest } from "./client";
import { useQuery } from "react-query";
const fetchCourseSupplemental = (courseId) => {
  return courseApiRequest({
    url: `/course-supplemental/course/${courseId}`,
    method: "GET"
  });
};
const fetchCourseSupplementalMerged = (courseId, districtId, schoolId, sectionId, enrollmentId) => {
  return courseApiRequest({
    url: `/course-supplemental/${courseId}/district/${districtId}/school/${schoolId}/section/${sectionId}/enrollment/${enrollmentId}/merged`,
    method: "GET"
  });
};
function useCourseSupplementalQuery(courseId, options) {
  return useQuery(
    ["course-supplemental", courseId],
    () => fetchCourseSupplemental(courseId),
    __spreadProps(__spreadValues({}, options), { useErrorBoundary: true })
  );
}
function useCourseSupplementalEnrollmentQuery(courseId, districtId, schoolId, sectionId, enrollmentId, options) {
  return useQuery(
    [
      "course-supplemental-enrollment",
      courseId,
      districtId,
      schoolId,
      sectionId
    ],
    () => {
      return fetchCourseSupplementalForEnrollment(
        courseId,
        districtId,
        schoolId,
        sectionId,
        enrollmentId
      );
    },
    __spreadProps(__spreadValues({}, options), {
      useErrorBoundary: true,
      enabled: !!courseId && !!districtId && !!schoolId && !!sectionId && !!enrollmentId
    })
  );
}
const fetchCourseSupplementalForEnrollment = (courseId, districtId, schoolId, sectionId, enrollmentId) => {
  return courseApiRequest({
    url: `/course-supplemental/${courseId}/district/${districtId}/school/${schoolId}/section/${sectionId}/enrollment/${enrollmentId}`,
    method: "GET"
  });
};
function useCourseSupplementalMergedQuery(courseId, districtId, schoolId, sectionId, enrollmentId, options) {
  return useQuery(
    [
      "course-supplemental",
      courseId,
      districtId,
      schoolId,
      sectionId,
      enrollmentId
    ],
    () => fetchCourseSupplementalMerged(
      courseId,
      districtId,
      schoolId,
      sectionId,
      enrollmentId
    ),
    __spreadProps(__spreadValues({}, options), {
      useErrorBoundary: true,
      enabled: !!courseId && !!districtId && !!schoolId && !!sectionId && !!enrollmentId
    })
  );
}
export {
  useCourseSupplementalEnrollmentQuery,
  useCourseSupplementalMergedQuery,
  useCourseSupplementalQuery
};
